/**
 * This agent's FACE — the surface it presents when it is the thing on screen.
 *
 * An agent has two representations and one implementation:
 *   - in-frame    — mounted by the main app in Home's detail pane
 *   - full-screen — mounted by this app at its own subdomain
 *
 * Both mount THIS component, so the two cannot drift. The module is how the
 * agent is packaged; the representation is only where it is mounted.
 *
 * The main app finds this file by CONVENTION, not from a registry: it globs
 * `apps/<slug>/src/face.tsx` and keys on the directory name — the same
 * filesystem discovery frontend/Dockerfile.local and build.yml already use.
 *
 * NAVIGATION IS SHARED TOO, now. The board's screens (a run, a curriculum
 * path) are declared once in ./routes and mounted by BOTH surfaces — this
 * app's App.tsx full-screen, the platform's AgentFrame in the pane — so the
 * board pushes one path and lands in the right place either way. It used to
 * pass surface-specific handlers through here, whose in-frame default was a
 * link OUT to this app: the quiz opened as a full page and the frame came off.
 */
import { LearnBoardConnected } from './components/learn'
import type { AgentFaceProps } from '@frontend/components/agentDetail/agentFace'

export default function Face(props: AgentFaceProps) {
  return <LearnBoardConnected {...props} />
}
